import axios from "axios";
import { createContext, useContext, useReducer } from "react";

const serverUrl = 'https://osdevhub.com/homify_backend';

const CommentContext = createContext();

const initialState = {
    comments: [],
    commentIsLoading: false,
    commentErrorMessage: false
}

function reducer(state, action) {
    switch (action.type) {
        case 'loading':
            return {
                ...state,
                commentIsLoading: true,
                commentErrorMessage: false
            };
        case 'commentError':
            return{
                ...state,
                commentErrorMessage: action.payload
            }
        case 'postComment':
            return{
                ...state,
                commentIsLoading: false,
            }
        case 'getComments':
            return{
                ...state,
                commentIsLoading: false,
                comments: action.payload,
            }
        case 'updateComment':
            return{
                ...state,
                commentIsLoading: false,
            }
        case 'deleteComment':
            return{
                ...state,
                commentIsLoading: false,
            }
    

            default:
                throw new Error("action unknown");
    }
}


function CommentProvider({children}) {

    const [{comments,
            commentIsLoading,
            commentErrorMessage,
        }, dispatch] = useReducer(reducer, initialState);

        async function updateComment(id, data) {
            dispatch({ type: 'loading' });
            try {
                const response = await axios.patch(`${serverUrl}/api/comments/${id}`, data, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
              if(response.data.message === "Comment updated successfully") {
                dispatch({
                  type: 'updateComment',
                })
              }
            } catch (error) {
              dispatch({
                type: 'commentError',
                payload: error.response?.data?.message || error.message || 'Error fetching comments for property'
            });

            console.error(error);
              
            }
      
          }

        async function getCommentsForProperty(property_id) {
            dispatch({ type: 'loading' });
        
            try {
                const response = await axios.get(`${serverUrl}/api/comments/${property_id}`);
        
                if (response.data.message === 'Comments retrieved successfully') {
                    dispatch({
                        type: 'getComments',
                        payload: response.data.data
                    });
                }
            } catch (error) {
                dispatch({
                    type: 'commentError',
                    payload: error.response?.data?.message || error.message || 'Error fetching comments for property'
                });
                console.error(error);
            }
        }

        async function postComment(commentData) {
            dispatch({ type: 'loading' });
        
            try {
                const response = await axios.post(`${serverUrl}/api/comments`, commentData);
        
                if (response.data.message === 'Comment added successfully') {
                    dispatch({
                        type: 'postComment',
                    });
                }
            } catch (error) {
                dispatch({
                    type: 'commentError',
                    payload: 'Error uploading comment'
                });
            }
        }
    
        async function getAllComments() {
            dispatch({
                type:'loading'
            })
            try {
                const response = await axios.get(serverUrl + '/api/comments');
                if (response.data.message === 'Comments retrieved successfully') {
                    dispatch({
                        type: 'getComments',
                        payload: response.data.data
                    })
                }
            } catch (error) {
                dispatch({
                    type: 'commentError',
                    payload: 'there is an error'
                })
                console.error(error);
                
            }
        } 

        async function deleteComment(id) {
            dispatch({
                type:'loading'
            })
            try {
             
                const response = await axios.delete(`${serverUrl}/api/comments/${id}`);
                if (response.data.message === 'Comment deleted successfully') {
                    dispatch({
                        type: 'deleteComment'
                    })
                }
            } catch (error) {
                dispatch({
                    type: 'commentError',
                    payload: 'error'
                })
            }
        }


    return (
        <CommentContext.Provider value={{        
            comments,
            commentIsLoading,
            commentErrorMessage,
            getCommentsForProperty,
            getAllComments,
            updateComment,
            postComment,
            deleteComment
            }}>
            {children}
        </CommentContext.Provider>
    )
}

function useComment() {
    const context = useContext(CommentContext);
    if (context === undefined) throw new Error("Comment context not used in the approapiate plate");
    return context;
}

export {CommentProvider, useComment}